import React from 'react';

import { formatDateTimeFromSeconds } from 'utils/dateUtil';
import { InspectionViewRequest, TxiViewRequest } from 'types/rest/analyticsTypes';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../../i18n';

type InspectionHeaderProps = {
  operation: string;
  seconds: boolean;
  requests: InspectionViewRequest | TxiViewRequest | null;
  method?: string;
};

/**
 * Creates header information from data available in the request object
 */
const InspectionDetailsHeader = (props: InspectionHeaderProps) => {
  const { t } = useTranslation('analytics');
  const timeStamp = props.requests
    ? formatDateTimeFromSeconds(parseInt(props.requests.timestamp) / 1000, props.seconds)
    : '';
  return (
    <h2 className="mb-0 text-truncate pt-2" title={props.operation + ' | ' + timeStamp}>
      <span className={'mr-3'}>
        {i18n.t('analytics:txInspection.detail.selectedRequest')}
        <span className={'text-muted'}>:</span>
      </span>
      {props.method && <>{props.method}</>}
      <span className="ml-3">
        {props.operation}
        <span className="text-muted ml-2 mr-2">|</span>
        {timeStamp}
      </span>
    </h2>
  );
};

export default InspectionDetailsHeader;
